import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-37288ad6"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["onKeydown"];
import ETooltip from '@common/ui/ETooltip.vue';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        value: { default: 0 },
        sliderDisabled: { type: Boolean },
        min: { default: 0 },
        max: { default: 100 },
        step: { default: 1 },
        showTooltip: { type: Boolean, default: true },
        formatTooltip: {},
        precision: {},
        emitChange: {},
        resetSize: {},
        sliderSize: {}
    },
    emits: ["changeDragging", "input"],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var hovering = ref(false);
        var dragging = ref(false);
        var isClick = ref(false);
        var startX = ref(0);
        var currentX = ref(0);
        var startY = ref(0);
        var currentY = ref(0);
        var startPosition = ref(0);
        var newPosition = ref(null);
        var oldValue = ref();
        var tooltipVisible = ref(false);
        var vertical = ref(false);
        var disabled = computed(function () {
            return props.sliderDisabled;
        });
        var currentPosition = computed(function () {
            return "".concat((props.value - props.min) / (props.max - props.min) * 100, "%");
        });
        var formatValue = computed(function () {
            return props.formatTooltip && props.formatTooltip(props.value) || ('' + props.value);
        });
        var wrapperStyle = computed(function () {
            return vertical.value ? { bottom: currentPosition.value } : { left: currentPosition.value };
        });
        watch(dragging, function (val) {
            emit('changeDragging', val);
        });
        onMounted(function () {
            oldValue.value = props.value;
        });
        var displayTooltip = function () {
            tooltipVisible.value = true;
        };
        var hideTooltip = function () {
            tooltipVisible.value = false;
        };
        var handleMouseEnter = function () {
            hovering.value = true;
            displayTooltip();
        };
        var handleMouseLeave = function () {
            hovering.value = false;
            hideTooltip();
        };
        var onButtonDown = function (event) {
            if (disabled.value)
                return;
            event.preventDefault();
            onDragStart(event);
            window.addEventListener('mousemove', onDragging);
            window.addEventListener('touchmove', onDragging);
            window.addEventListener('mouseup', onDragEnd);
            window.addEventListener('touchend', onDragEnd);
            window.addEventListener('contextmenu', onDragEnd);
        };
        var onLeftKeyDown = function () {
            if (disabled.value)
                return;
            newPosition.value = parseFloat(currentPosition.value) - props.step / (props.max - props.min) * 100;
            setPosition(newPosition.value);
            props.emitChange();
        };
        var onRightKeyDown = function () {
            if (disabled.value)
                return;
            newPosition.value = parseFloat(currentPosition.value) + props.step / (props.max - props.min) * 100;
            setPosition(newPosition.value);
            props.emitChange();
        };
        var onDragStart = function (event) {
            dragging.value = true;
            isClick.value = true;
            if (event.type === 'touchstart') {
                event.clientY = event.touches[0].clientY;
                event.clientX = event.touches[0].clientX;
            }
            if (vertical.value) {
                startY.value = event.clientY;
            }
            else {
                startX.value = event.clientX;
            }
            startPosition.value = parseFloat(currentPosition.value);
            newPosition.value = startPosition.value;
        };
        var onDragging = function (event) {
            if (dragging.value) {
                isClick.value = false;
                displayTooltip();
                props.resetSize && props.resetSize();
                var diff = 0;
                if (event.type === 'touchmove') {
                    event.clientY = event.touches[0].clientY;
                    event.clientX = event.touches[0].clientX;
                }
                if (vertical.value) {
                    currentY.value = event.clientY;
                    diff = (startY.value - currentY.value) / props.sliderSize * 100;
                }
                else {
                    currentX.value = event.clientX;
                    diff = (currentX.value - startX.value) / props.sliderSize * 100;
                }
                newPosition.value = startPosition.value + diff;
                setPosition(newPosition.value);
            }
        };
        var onDragEnd = function () {
            if (dragging.value) {
                /*
                     * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
                     * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
                     */
                setTimeout(function () {
                    dragging.value = false;
                    hideTooltip();
                    if (!isClick.value) {
                        setPosition(newPosition.value);
                        props.emitChange();
                    }
                }, 0);
                window.removeEventListener('mousemove', onDragging);
                window.removeEventListener('touchmove', onDragging);
                window.removeEventListener('mouseup', onDragEnd);
                window.removeEventListener('touchend', onDragEnd);
                window.removeEventListener('contextmenu', onDragEnd);
            }
        };
        var setPosition = function (newPosition) {
            if (newPosition === null || isNaN(newPosition))
                return;
            if (newPosition < 0) {
                newPosition = 0;
            }
            else if (newPosition > 100) {
                newPosition = 100;
            }
            var lengthPerStep = 100 / ((props.max - props.min) / props.step);
            var steps = Math.round(newPosition / lengthPerStep);
            var value = steps * lengthPerStep * (props.max - props.min) * 0.01 + props.min;
            value = parseFloat(value.toFixed(props.precision));
            emit('input', value);
            nextTick(function () {
                displayTooltip();
                //this.$refs.tooltip && this.$refs.tooltip.updatePopper();
            });
            if (!dragging.value && props.value !== oldValue.value) {
                oldValue.value = props.value;
            }
        };
        __expose({
            setPosition: setPosition,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                ref: "button",
                class: _normalizeClass([{ 'hover': hovering.value, 'dragging': dragging.value }, "e-range-slider__button-wrapper"]),
                style: _normalizeStyle(wrapperStyle.value),
                tabindex: "0",
                onBlur: handleMouseLeave,
                onFocus: handleMouseEnter,
                onKeydown: [
                    _withKeys(_withModifiers(onLeftKeyDown, ["prevent"]), ["down"]),
                    _withKeys(onLeftKeyDown, ["left"]),
                    _withKeys(onRightKeyDown, ["right"]),
                    _withKeys(_withModifiers(onRightKeyDown, ["prevent"]), ["up"])
                ],
                onMousedown: onButtonDown,
                onMouseenter: handleMouseEnter,
                onMouseleave: handleMouseLeave,
                onTouchstart: onButtonDown
            }, [
                _createVNode(ETooltip, {
                    "append-to-body": false,
                    disabled: !_ctx.showTooltip,
                    "tooltip-text": formatValue.value,
                    visible: hovering.value || dragging.value,
                    trigger: "manual",
                    unselectable: ""
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", {
                            class: _normalizeClass([{ 'hover': hovering.value, 'dragging': dragging.value }, "e-range-slider__button"])
                        }, null, 2)
                    ]; }),
                    _: 1
                }, 8, ["disabled", "tooltip-text", "visible"])
            ], 46, _hoisted_1));
        };
    }
});
